'use client';
import { useEffect, useState } from 'react';
import styles from './showmorecatagory.module.scss';
import { Button } from '@/ui-components/atoms/Button/Button';
import { ContentCategory, ContentCategoryProps } from '../ContentCategory/ContentCategory';

export interface ShowMoreContentCategoryProps {
    showText?: string;
    hideText?: string;
    className?: string;
    onClickHandler?: () => void;
    isContentShown?: boolean;
    content: ContentCategoryProps;
    initialItemsToShow?: number;
}

export function ShowMoreContentCategory({
    showText = 'Show more',
    hideText = 'Show less',
    onClickHandler,
    isContentShown = false,
    content,
    initialItemsToShow = 12,
}: ShowMoreContentCategoryProps): React.JSX.Element {
    const [contentShown, setContentShown] = useState(false);
    const { items, ...restContent } = content;

    useEffect(() => {
        setContentShown(isContentShown);
    }, [isContentShown]);

    const displayedItems = contentShown ? items : items.slice(0, initialItemsToShow);
    const handleClick = () => {
        if (onClickHandler) {
            onClickHandler();
        } else {
            setContentShown(!contentShown);
        }
    };

    return (
        <>
            <ContentCategory {...restContent} items={displayedItems} />
            {items.length > initialItemsToShow && (
                <div className={styles.buttonWrapper}>
                    <Button
                        onClick={() => handleClick()}
                        variant="tertiary"
                        tertiaryNoPadding
                        type="button"
                        fitting="hug-contents"
                    >
                        <span className={styles.contentText}>{contentShown ? hideText : showText} </span>
                    </Button>
                </div>
            )}
        </>
    );
}
